import { useTranslation } from 'next-i18next'

export default function AboutCadsoma () {
  const { t } = useTranslation(['plugins'])

  return (
    <div className="about py-5">
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-lg-9 col-xl-7">
                <div className="text-white">
                  <span className="badge text-uppercase mb-3">Cadsoma</span>
                  <span className="h2 fw-bold text-white d-block">
                    {t('about_cadsoma.title')}
                  </span>
                  <p className="mt-3">
                    {t('about_cadsoma.description_1')}
                  </p>
                  <p className="mt-3">
                    {t('about_cadsoma.description_2')}
                  </p>
                  <p className="mt-3 fw-bold">
                    {t('about_cadsoma.description_3')}
                  </p>
                </div>
              </div>
              <div className="col-12">
                <div className="row justify-content-between">
                  {
                    t('about_cadsoma.elements', { returnObjects: true }).map((element, key) => (
                      <div
                        key={key}
                        className="col-12 col-lg-4"
                      >
                        <div className="border-bottom">
                          <span className="text-white fw-bold fs-2">{element.title}</span>
                          <p className="text-white">
                            {element.description}
                          </p>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
